import Stripe from './Stripe';
import Quotation from './Quotation';

export default class QuotationStripe extends Stripe {
    constructor(payload) {
        super(payload);
        this.quotations = [new Quotation()];
    }
}
